export default "__VITE_ASSET__DNitEs0B__"